import React, { useState, useEffect, useContext } from 'react';

// ------------------ COMPONENTES DE BASE--------------------------------
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import OverlayPanelTemplate from '../../../../../Base/Components/Overlays/OverlayPanelTemplate';

// ------------------- CONSULTAS A LA API--------------------------------
import { getPurchaseByCurrency } from '../../../../../API/Compras/Requisas/PurchaseRequest';

const ItemOverlayPanel = ({selectedItemChange, overlayItemRef, IdPurchaseOrderDetail, IdComponent, IdCurrency, IdVendor }) => {

    const { userAuth } = useContext(AuthContext);

    const [ordenesCompraAuth, setOrdenesCompraAuth] = useState([]);
    const [loading, setLoading] = useState(false);

    const Columns = [
        {
            // ID
            field: "IdPurcharesRequestDetail",
            header: "ID Detalle",
            headerEn: "ID Detail",
            className: "Xsmall",
            frozen: true,
            hidden: userAuth.IdRol === 1,
          },
        {
            // REQUISA
            field: 'PurchaseRequest',
            header: 'Requisa',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // PRODUCTO
            field: 'CodigoProducto',
            header: 'Código de Producto',
            className: "large",
            sortable: true,
            filter: true
        },
        {
            // PRODUCTO
            field: 'NombreProducto',
            header: 'Producto',
            className: "large",
            sortable: true,
            filter: true
        },
        {
            // CATEGORIA
            field: 'NombreCategoria',
            header: 'Categoria',
            className: "medium",
            sortable: true,
            filter: true
        },
        {
            // TIPO
            field: 'Type',
            header: 'Tipo',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // PRECIO
            field: 'Price',
            header: 'Precio',
            Format: 'Currency',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // MONEDA
            field: 'CurrencySymbol',
            header: 'Moneda',
            className: "small",
            Format: 'Center',
            sortable: true,
            filter: true
        },
        {
            // CANTIDAD
            field: 'Quantity',
            header: 'Cantidad',
            Format: 'Currency',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // UNIDAD
            field: 'UnitSimbol',
            header: 'Unidad',
            className: "small",
            Format: 'Center',
            sortable: true,
            filter: true
        },
        {
            // SUBTOTAL
            field: 'SubTotal',
            header: 'SubTotal',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },
        {
            // DESCUENTO
            field: 'Discount',
            header: 'Descuento',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },
        {
            // TOTAL
            field: 'Total',
            header: 'Total',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },

    ]


    const table = {
        Data: ordenesCompraAuth,
        Columns: Columns,
        editMode: 'cell',
        loading: loading,
        onCellClicked: e => selectedItemChange(e, IdPurchaseOrderDetail)
    };

    // Esta función se ejecutará cada vez que cambie IdCurrency o IdVendor
    useEffect(() => {
        const obtenerListadoOrdenes = async () => {
            setLoading(true);
            try {
                const tempo = await getPurchaseByCurrency(IdCurrency, IdVendor);
                setOrdenesCompraAuth(tempo);
            } catch (error) {
                console.error('Error al obtener los datos de la API:', error);
            } finally {
                setLoading(false);
            }
        };
    
        obtenerListadoOrdenes();
    }, [IdCurrency, IdVendor]);
    
    


    useEffect(() => {
        if (ordenesCompraAuth.length > 0) {
            setLoading(false);
          }
          setLoading(false);
    }, [ordenesCompraAuth])


    const overlayContent = (
        <div style={{ height: 300 }}>
            <AgGrid styles={{ maxHeight: '100px' }} table={table} />
        </div>
    )

    return (
        <div>
            <OverlayPanelTemplate
                InputValue={IdComponent}
                overlayRef={overlayItemRef}
                overlayContent={overlayContent}
                dismissable={false}
                styles={{
                    maxHeight: '500px',
                    width: 1000
                 }}
            />
        </div>
    )
}

export default ItemOverlayPanel